// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-align:baseline;align-items:baseline;-webkit-column-gap:30px;-moz-column-gap:30px;column-gap:30px;margin-left:0;margin-right:0}.col,.col-6{padding-left:0;padding-right:0}.col-6{-ms-flex-preferred-size:calc(50% - 15px);flex-basis:calc(50% - 15px)}.btn--primary.btn--delete{background-color:#da1818}", ""]);
// Exports
module.exports = exports;
